export default __webpack_public_path__ + "static/media/003-sailor-cap-2.ee64852a.png";